<template src='./betterModal.pug' lang='pug'></template>

<script>
import ButtonPrimary from '../../buttons/buttonPrimary/ButtonPrimary'
import { trackAnalyticsEvent } from '../../../utils/analytics.js'
import { AutoFocus } from '../../../utils/directives.js'
import popExitingConfirmation from '../../../utils/popExitingConfirmation.js'

export default {
  name: 'BetterModal',

  components: {
    ButtonPrimary
  },

  props: {
    closable: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      required: true
    },
    checkForUnsavedChanges: {
      type: Boolean,
      default: false
    },
    defaultCloseButton: {
      type: Boolean,
      default: false
    },
    tabbedModal: {
      type: Boolean,
      default: false
    },
    showFooter: {
      type: Boolean,
      default: true
    },
    bringBack: {
      type: Boolean,
      default: false
    }
  },

  directives: {
    AutoFocus
  },

  computed: {
    hasUnsavedChanges () {
      return this.$store.getters.hasUnsavedChanges
    }
  },

  methods: {
    close () {
      if (this.checkForUnsavedChanges && this.hasUnsavedChanges && !popExitingConfirmation()) {
        return
      }
      trackAnalyticsEvent(this, 'close-modal', 'titlebar-close-modal-click', this.id)
      if (this.closable) {
        this.$emit('close-modal')
      }
    }
  }
}
</script>

<style>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.bring-back {
  z-index: 254 !important;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  border-radius: 3px;
  margin: 0px auto;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header {
  padding: 0 15px 0;
  font-family: 'Inter', sans-serif;
font-weight: 700;
  background-color: #fff;
  color: #1b3c65;
  border-bottom: 2px solid #d0d0d0;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}

.modal-header h1 {
  font-size: 2em;
  margin-top: 15px;
  margin-bottom: 0px;
}

.modal-header h4 {
  margin-top: 5px;
  margin-left: 2px;
  margin-bottom: 10px;
}

.modal-header button {
  color: #b1b1b1;
  margin: 15px 10px 0px 0px !important;
  font-size: 40px;
  opacity: 1 !important;
}

.modal-header button:hover {
  color: #1b3c65;
}

.modal-default-button {
  float: right;
}

.modal-footer .modal-tabbed {
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */
.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: translateY(-100px);
  transform: translateY(-100px);
}
</style>



// WEBPACK FOOTER //
// BetterModal.vue?e32b5844